import { Head } from "@inertiajs/react";
import { Box, Container, Heading, Section } from "@radix-ui/themes";
import EventFeed from "@/shared/events/EventFeed";
import type { BrandedHomeProps } from "@/types/branded_home";

// A branded site's front page, and its events page: the brand's events as a
// feed — the wireframe's screen 1 (tickets/white-label-media-application-flow.md).
export default function BrandedHome({ name, show_track, upcoming, past }: BrandedHomeProps) {
  return (
    <>
      <Head title={name} />
      <Section size="1" px="4">
        <Container size="4">
          <Heading size="8" mb="6">
            {name} events
          </Heading>
          <Box>
            <EventFeed
              upcoming={upcoming}
              recent={past}
              showTrack={show_track}
              emptyMessage={`No events from ${name} yet.`}
            />
          </Box>
        </Container>
      </Section>
    </>
  );
}
